// extracted by mini-css-extract-plugin
export var icon = "_82-1";
export var subtext = "_82-0";